module.exports = __webpack_public_path__ + "static/media/menu.33b58f4c.svg";